let lastTimestamp = 0;
let sequence = 0;

function getTabSalt() {
  if (typeof window === "undefined") return 0;

  const existing = window.sessionStorage.getItem("evren_tab_salt");
  if (existing) return Number(existing) || 0;

  const next = Math.floor(Math.random() * 100);
  window.sessionStorage.setItem("evren_tab_salt", String(next));
  return next;
}

export function createClientNumericId() {
  const now = Date.now();

  if (now === lastTimestamp) {
    sequence = (sequence + 1) % 10;
  } else {
    lastTimestamp = now;
    sequence = 0;
  }

  const suffix = getTabSalt() * 10 + sequence;
  return now * 1000 + suffix;
}
